import { Controller } from "@hotwired/stimulus"

// Turns a payment search result (see _overpayment_line) into an overpayment allocation row
// inside the unprocessings form: the template row is cloned with a unique index, then filled
// with the clicked payment's id and label. The lettering controller picks the new inputs up
// through its target lifecycle callbacks.
export default class extends Controller {
  static targets = ["template", "container", "searchInput", "results"]

  connect() {
    this.index = 0
  }

  add(event) {
    const { paymentId, label } = event.currentTarget.dataset
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.index++)
    this.containerTarget.insertAdjacentHTML("beforeend", html)

    const row = this.containerTarget.lastElementChild
    row.querySelector("[data-overpayment-payment-id]").value = paymentId
    row.querySelector("[data-overpayment-label]").textContent = label

    this.resultsTarget.innerHTML = ""
    this.searchInputTarget.value = ""
  }

  remove(event) {
    event.currentTarget.closest(".overpayment-row").remove()
  }
}
